import { BRAND_CONFIG } from '@@brand'
import { useTranslation } from 'react-i18next'

// import { ReactSVG } from "react-svg";
import { useFetchMyBonusTotal } from '@entities/Loyalty'

import Wrapper from '@shared/ui/wrapper'

import { Card } from './Card'
import { CurrentLevelInfo } from './CurrentLevelInfo'
import { Savings } from './Savings'
// import { Cashback } from "./Сashback";

import styles from './styles.module.scss'

export default function PersonalBonus () {
  const { i18n } = useTranslation('personal')
  const { bonus: myBonus } = useFetchMyBonusTotal()

  // Get brand-specific loyalty name for current language
  const loyaltyName = BRAND_CONFIG.loyalty.name[i18n.language as 'ru' | 'kk' | 'en'] || BRAND_CONFIG.loyalty.name.ru

  // номер активной карты
  const activeCardNumber = myBonus?.bonusCards?.find(
    (card) => card?.status === 'active',
  )?.cardNumber

  // сумма бонусов в статусе "в ожидании"
  const pendingBonusesAmount = myBonus?.pendingBonuses?.reduce(
    (sum, item) => sum + (item?.amount || 0),
    0,
  )

  const bonusExpireAt = myBonus?.nearestExpiringBonus
    ? new Date(myBonus.nearestExpiringBonus.expireAt).toLocaleDateString(
      'ru-RU',
      {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      },
    )
    : null

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <div className={styles.root__content}>
          <h2 className={styles.root__title}>{loyaltyName}</h2>
          <Card
            balance={myBonus?.activeBonuses}
            cardNumber={activeCardNumber}
            pendingBonusesAmount={pendingBonusesAmount}
            bonusExpireAmount={myBonus?.nearestExpiringBonus?.expireAmount}
            bonusExpireAt={bonusExpireAt}
            className={styles.root__container}
          />
          <CurrentLevelInfo className={styles.root__container} />
          <Savings className={styles.root__container} />
          {/* <div className={styles.root__trash}>
            <ReactSVG src="/icons/trash.svg" />
            <span>{tn("bonus.delete")}</span>
          </div> */}
          {/* //временно скрыли */}
        </div>
      </Wrapper>
    </div>
  )
}
